"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.regexp.to-string");

require("/mnt/www/planning-web-v2/node_modules/core-js/modules/es6.array.iterator.js");

require("/mnt/www/planning-web-v2/node_modules/core-js/modules/es6.promise.js");

require("/mnt/www/planning-web-v2/node_modules/core-js/modules/es6.object.assign.js");

require("/mnt/www/planning-web-v2/node_modules/core-js/modules/es7.promise.finally.js");

require("./styles/main.scss");

require("./styles/vendors/tailwind.css");

var _vue = _interopRequireDefault(require("vue"));

var _elementUi = require("element-ui");

var _router = require("./router");

var _store = require("./store");

var _translations = require("./translations");

var _App = _interopRequireDefault(require("./App.vue"));

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");

var _vueFontawesome = require("@fortawesome/vue-fontawesome");

var _moment = _interopRequireDefault(require("moment"));

var _vCalendar = _interopRequireDefault(require("v-calendar"));

_vue.default.use(_elementUi.Loading.directive);

_vue.default.use(_vCalendar.default);

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCopyright, _freeSolidSvgIcons.faLock, _freeSolidSvgIcons.faBars, _freeSolidSvgIcons.faSignOutAlt, _freeRegularSvgIcons.faEye, _freeRegularSvgIcons.faEyeSlash, _freeSolidSvgIcons.faSave, _freeSolidSvgIcons.faTrashAlt, _freeSolidSvgIcons.faSync, _freeSolidSvgIcons.faTruckMoving, _freeSolidSvgIcons.faColumns, _freeSolidSvgIcons.faExpand, _freeSolidSvgIcons.faPlusCircle, _freeSolidSvgIcons.faMinusCircle, _freeSolidSvgIcons.faLocationArrow, _freeSolidSvgIcons.faRoute, _freeSolidSvgIcons.faClock, _freeSolidSvgIcons.faPeopleCarry, _freeSolidSvgIcons.faEdit, _freeSolidSvgIcons.faGlobeAsia, _freeSolidSvgIcons.faCheckCircle, _freeSolidSvgIcons.faInfoCircle, _freeSolidSvgIcons.faExclamationTriangle, _freeSolidSvgIcons.faSign, _freeSolidSvgIcons.faUserLock, _freeSolidSvgIcons.faBan, _freeSolidSvgIcons.faWrench, _freeSolidSvgIcons.faCaretDown, _freeSolidSvgIcons.faCaretUp, _freeSolidSvgIcons.faEraser, _freeSolidSvgIcons.faUndo, _freeSolidSvgIcons.faPen, _freeSolidSvgIcons.faTrash, _freeSolidSvgIcons.faMap, _freeSolidSvgIcons.faExclamationCircle, _freeRegularSvgIcons.faWindowRestore, _freeSolidSvgIcons.faFileUpload, _freeSolidSvgIcons.faFileDownload, _freeSolidSvgIcons.faPrint, _freeSolidSvgIcons.faSearch, _freeSolidSvgIcons.faFileExcel, _freeSolidSvgIcons.faCircle, _freeRegularSvgIcons.faCircle, _freeSolidSvgIcons.faMapMarkerAlt, _freeSolidSvgIcons.faExpandArrowsAlt, _freeSolidSvgIcons.faCompressArrowsAlt, _freeSolidSvgIcons.faCopy, _freeSolidSvgIcons.faShare, _freeSolidSvgIcons.faBell, _freeSolidSvgIcons.faUserFriends, _freeRegularSvgIcons.faDotCircle, _freeSolidSvgIcons.faParachuteBox, _freeSolidSvgIcons.faUser, _freeSolidSvgIcons.faPlay, _freeSolidSvgIcons.faPause, _freeSolidSvgIcons.faStop, _freeSolidSvgIcons.faHands, _freeSolidSvgIcons.faMapMarker, _freeSolidSvgIcons.faLightbulb, _freeSolidSvgIcons.faPalette, _freeSolidSvgIcons.faLanguage, _freeSolidSvgIcons.faServer, _freeSolidSvgIcons.faMapMarkedAlt, _freeRegularSvgIcons.faMap, _freeSolidSvgIcons.faSort, _freeSolidSvgIcons.faSortDown, _freeSolidSvgIcons.faSortUp, _freeSolidSvgIcons.faWarehouse, _freeSolidSvgIcons.faPaperPlane, _freeSolidSvgIcons.faCheckDouble, _freeSolidSvgIcons.faFeather, _freeSolidSvgIcons.faBullhorn, _freeSolidSvgIcons.faFileCsv, _freeSolidSvgIcons.faBackspace, _freeSolidSvgIcons.faRandom);

_vue.default.component('font-awesome-icon', _vueFontawesome.FontAwesomeIcon);

_vue.default.component('font-awesome-layers', _vueFontawesome.FontAwesomeLayers);

_vue.default.config.productionTip = false;
var store = (0, _store.createStore)(_vue.default);
var router = (0, _router.createRouter)(_vue.default, store);
var i18n = (0, _translations.createTranslation)(_vue.default);

_vue.default.filter('convertTimezone', function (d) {
  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YY-MM-DD HH:mm';

  if (d === null || d === undefined) {
    return d;
  }

  d = d.toString();

  if (timezone !== 8) {
    var date = _moment.default.utc(d).subtract(8, 'hours').utcOffset(timezone);

    return date.format(format);
  } else {
    return (0, _moment.default)(d).format(format);
  }
});

new _vue.default({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(_App.default);
  }
}).$mount('#app');